import { render, staticRenderFns } from "./PrelievoDetailModal.vue?vue&type=template&id=2b20e8d4&"
import script from "./PrelievoDetailModal.vue?vue&type=script&lang=js&"
export * from "./PrelievoDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./PrelievoDetailModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports